import React from "react";

const EulaPrivacyText = (props) => {
  return (
    <>
      <h4>개인정보 처리방침</h4>
      <p>
        모빌리전트 주식회사(이하 ‘회사’라고 함)는 정보주체의 개인정보를 소중하게
        생각하며, 개인정보 처리방침을 공개함으로써 회원이 언제나 쉽고 편하게
        이를 확인할 수 있도록 하고 있습니다. 회사는 개인정보처리방침을 관련 법령
        또는 내부사정에 따라 개정할 수 있으며, 개정하는 경우 개정된 사항을
        회원이 수시로 확인할 수 있도록 게시합니다.
      </p>
      <h5>제1조 개인정보의 수집·이용 목적, 항목 및 수집 방법</h5>
      <p>
        1. 회사는 다음과 같은 목적으로 개인정보를 수집하고 있습니다. 수집하고
        있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이
        변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 것입니다.
      </p>
      <ol>
        <li>
          이용자 식별 및 본인 여부 확인, 회원가입, 문의사항 또는 불만처리 등
          회원관리를 위한 목적
        </li>
        <li>회사의 서비스 제공</li>
        <li>
          제휴사 포인트 정보 수신, 서비스 이용내역의 제휴사 제공을 위한 목적
        </li>
        <li>
          법령 및 이용약관을 위반하는 회원에 대한 이용 제한 조치, 부정 이용
          행위를 포함하여 서비스의 원활한 운영에 지장을 주는 행위 및 비인가
          행위에 대한 방지 및 제재, 계정도용 및 부정거래 방지, 고지사항 전달,
          분쟁 조정을 위한 기록보존 등 회원 보호 및 서비스의 정상적인 운영을
          위한 목적
        </li>
        <li>
          인구통계학적 특성에 따른 서비스 제공, 접속 빈도 분석, 기능개선, 서비스
          이용에 대한 통계, 서비스 분석 및 통계에 기반하여 회원의 서비스 이용
          성향, 관심, 이용기록 분석 등을 반영한 신규 서비스 개발 및 제공 등을
          위한 목적
        </li>
        <li>이벤트 제공 및 마케팅 활용 등을 위한 목적</li>
        <li> 제휴사의 포인트 연동/교환을 위한 목적</li>
        <li> 중복가입 및 이벤트 중복 참여 확인 목적</li>
      </ol>
      <p>2. 회사는 다음과 같은 항목의 개인정보를 수집할 수 있습니다.</p>
      <ol>
        <li> 서비스 가입시 필수 수집 항목 : 이메일, 비밀번호</li>
        <li>
          본인인증 시 필수 수집 항목 : 성명, 생년월일, 성별, 내외국인구분,
          휴대폰번호, 연계정보(CI), 중복가입확인정보(DI), 통신사 정보
        </li>
        <li>
          서비스 이용과정 및 처리를 위한 필수 수집항목 : 서비스 이용 기록,
          디바이스 고유값, 접속 로그, MAC어드레스, 접속 IP, 불량 이용 기록,
          제휴사 연동 및 거래 이력, 포인트 거래이력, 결제이력, 부리또 지갑주소
          및 거래이력, 탈퇴 해지 이력, 문의 및 답변 이력
        </li>
        <li>
          서비스 제공을 위한 선택항목 : 마케팅활용수신동의(휴대폰번호, 이메일),
          이벤트 경품 당첨안내 및 배송지 확인(주소)
        </li>
      </ol>
      <p>
        3. 회사는 다음과 같은 항목의 개인정보를 제3자로부터 제공받아 보유 및
        이용할 수 있습니다.
      </p>
      <table>
        <thead>
          <tr>
            <th>제공하는 자</th>
            <th>이용 목적</th>
            <th>수집 항목</th>
            <th>보유 및 이용 기간</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>주식회사 네이앤컴퍼니</td>
            <td>
              서비스 제휴(연동 및 해제, 적립, 사용, 조회, 회수 및 반환
              등), 민원처리 등 소비자 분쟁해결
            </td>
            <td>CI, 네이코인 보유 현황 및 거래정보 </td>
            <td>
              회원 탈퇴 후 30일까지, 또는 관계법령상 의무보존기간 중 더 늦은
              날까지
            </td>
          </tr>
          <tr>
            <td>아모블록 주식회사</td>
            <td>
              서비스 제휴(연동 및 해제, 적립, 사용, 조회, 회수 및 반환
              등), 민원처리 등 소비자 분쟁해결
            </td>
            <td>CI, 일회용지갑주소, 거래정보</td>
            <td>
              회원 탈퇴 후 30일까지, 또는 관계법령상 의무보존기간 중 더 늦은
              날까지
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        4. 회사는 다음과 같은 방법으로 개인정보를 수집하고 있습니다. 회사는
        회원의 서비스 이용 도중 추가적인 정보를 수집할 수 있으며, 이 경우 별도의
        개인정보 수집·이용 동의를 받습니다.
      </p>
      <ol>
        <li> 모바일 기기, 서면 양식, 전화, 게시판, 이메일을 통한 수집</li>
        <li>
          이벤트 및 프로모션 등 개인정보 처리업무 수탁사 또는 제휴사로부터의
          제공
        </li>
        <li>
          휴대전화 및 유·무선 인터넷 서비스 사용 시 생성정보를 수집하는 도구를
          통한 방법
        </li>
      </ol>
      <p>
        5. 회사는 회원의 기본적 인권을 침해할 우려가 있는 민감한 개인정보(인종,
        종교, 사상, 정치적 성향, 범죄기록, 건강상태 등)는 수집하지 않습니다.
      </p>
      <h5>제2조 개인정보의 보유 및 이용 기간</h5>
      <p>
        회사는 원칙적으로 회원의 개인정보를 회원탈퇴 시까지 보관합니다. 단,
        다음의 개인정보에 대해서는 회원탈퇴 후에도 법령에 따른 보유 기간 동안
        보관합니다.
      </p>
      <ul>
        <li>1) 전자금융 거래에 관한 기록</li>
        <li>- 보유 기간 : 5년(단, 건별 거래금액 1만원 미만은 1년)</li>
        <li>- 보유 이유 : 전자금융거래법</li>

        <li>2) 계약 또는 청약철회 등에 관한 기록</li>
        <li>- 보유 기간 : 5년</li>
        <li>- 보유 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>
        <li>3) 대금결제 및 재화 등의 공급에 관한 기록</li>
        <li>- 보유 기간 : 5년</li>
        <li>- 보유 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>
        <li>4) 소비자의 불만 또는 분쟁처리에 관한 기록</li>
        <li>- 보유 기간 : 3년</li>
        <li>- 보유 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>
        <li>5) 본인확인에 관한 기록</li>
        <li>- 보유 기간 : 6개월</li>
        <li>- 보유 이유 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률</li>
        <li>6) 웹사이트 방문기록</li>
        <li>- 보유 기간 : 3개월</li>
        <li>- 보유 이유 : 통신비밀보호법</li>
      </ul>
      <h5>제3조 개인정보의 제3자 제공에 대한 사항</h5>
      <p>
        1. 회사는 개인정보를 수집한 목적 범위에서 개인정보를 이용하며, 그 범위를
        초과하여 개인정보를 이용하거나 제3자에게 제공∙공유하지 않습니다. 다만,
        다음의 경우는 예외로 합니다.
      </p>
      <ol>
        <li>정보주체로부터 별도의 동의를 받은 경우</li>
        <li>다른 법률에 특별한 규정이 있는 경우</li>
        <li>
          정보주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나
          주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 정보주체 또는
          제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는
          경우
        </li>
        <li>
          통계작성 및 학술연구 등의 목적을 위하여 필요한 경우로서 특정 개인을
          알아볼 수 없는 형태로 개인정보를 제공하는 경우
        </li>
        <li>
          개인정보를 목적 외의 용도로 이용하거나 이를 제3자에게 제공하지
          아니하면 다른 법률에서 정하는 소관 업무를 수행할 수 없는 경우로서
          보호위원회의 심의·의결을 거친 경우 조약, 그 밖의 국제협정의 이행을
          위하여 외국정부 또는 국제기구에 제공하기 위하여 필요한 경우
        </li>
        <li>
          범죄의 수사와 공소의 제기 및 유지를 위하여 필요한 경우 법원의 재판업무
          수행을 위하여 필요한 경우
        </li>
        <li>형(刑) 및 감호, 보호처분의 집행을 위하여 필요한 경우</li>
      </ol>
      <p>
        2. 회사의 서비스 이행을 위하여 개인정보를 제3자에게 제공하고 있는 경우는
        아래와 같습니다.
      </p>
      <table>
        <thead>
          <tr>
            <th>제공받는 자</th>
            <th>이용 목적</th>
            <th>제공 항목</th>
            <th>보유 및 이용 기간</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>주식회사 네이앤컴퍼니</td>
            <td>
              서비스 제휴(연동 및 해제, 적립, 사용, 조회, 회수 및 반환
              등), 민원처리 등 소비자 분쟁해결
            </td>
            <td>회원의 CI, MU포인트</td>
            <td>
              회원 탈퇴 후 30일까지, 또는 관계법령상 의무보존기간 중 더 늦은
              날까지
            </td>
          </tr>
          <tr>
            <td>아모블록 주식회사</td>
            <td>
              서비스 제휴(연동 및 해제, 적립, 사용, 조회, 회수 및 반환
              등), 민원처리 등 소비자 분쟁해결
            </td>
            <td>회원의 CI, MU포인트 보유 현황 및 거래정보 </td>
            <td>
              회원 탈퇴 후 30일까지, 또는 관계법령상 의무보존기간 중 더 늦은
              날까지
            </td>
          </tr>
        </tbody>
      </table>
      <h5>제4조 개인정보 처리 위탁에 관한 사항</h5>
      <p>
        회사는 원활한 서비스 제공과 효과적인 업무처리를 위하여 다음과 같이
        개인정보 처리 업무를 외부 업체에 위탁하고 있습니다. 회사는 수탁자들이
        위탁 받은 개인정보를 안전하게 처리하고 있는지 지속적으로 관리 감독하고
        있으며, 수탁업무가 종료된 때에 수탁자가 보유하고 있는 개인정보를 즉시
        파기하게 하고 있습니다.
      </p>
      <table>
        <thead>
          <tr>
            <th>위탁 받는 자</th>
            <th>위탁 업무</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>아모블록 주식회사 </td>
            <td>시스템 운영 및 유지보수</td>
          </tr>
          <tr>
            <td>주식회사 다날 </td>
            <td>휴대폰 본인인증</td>
          </tr>
          <tr>
            <td>AWS</td>
            <td>서비스 제공을 위한 서버/인프라 운영 및 데이터 보관</td>
          </tr>
        </tbody>
      </table>
      <h5>제5조 개인정보의 파기에 관한 사항</h5>
      <p>
        회사는 원칙적으로 개인정보 수집·이용 목적이 달성되거나 회원으로부터 동의
        받은 보유 및 이용기간이 경과되면 해당 정보를 지체 없이
        파기합니다. 파기절차 및 방법은 다음과 같습니다.
      </p>
      <p>1. 파기절차</p>
      <p>
        즉시 파기되는 경우 이외에는 수집,이용 목적이 달성된 정보의 경우
        별도의 DB에 옮겨져 내부규정 및 관련 법령을 준수하여 안전하게
        보관되며, 정해진 기간이 종료되었을 때 지체 없이 파기됩니다. 이
        때, 별도의 DB로 옮겨진 정보는 회원 각자가 동의한 목적을 초과하거나
        법률에 정한 경우가 아니면 다른 목적으로 이용되지 않습니다.
      </p>
      <p>2. 파기방법</p>
      <ol>
        <li>
          전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여
          삭제합니다.
        </li>
        <li>
          종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
        </li>
      </ol>
      <h5>제6조 회원의 권리와 그 행사 방법에 관한 사항</h5>
      <p>
        1. 회원은 회사에 대해 언제든지 다음의 개인정보 보호 관련 권리를 행사할
        수 있습니다
      </p>
      <ol>
        <li>개인정보 열람 요구</li>
        <li>개인정보 정정·삭제 요구</li>
        <li>개인정보 처리정지 요구</li>
      </ol>
      <p>
        단, 회사는 다른 법령에서 그 개인정보가 수집대상으로 명시되어 있는
        경우에는 삭제 요구에 응하지 않을 수 있습니다.
      </p>
      <p></p>
      <p>
        2. 회원은 제1항에 따른 권리를 행사할 경우에는 어플리케이션 내 회원정보를
        클릭하여 직접 할 수 있고, 제1항 내지 제3항에 따른 권리를 행사할 경우
        개인정보관리책임자 및 담당부서에게 서면, 전화, 이메일 등을 통하여 요청할
        수 있습니다.
      </p>
       
      <p>
        3. 회원은 법정대리인 또는 회원으로부터 위임을 받은 대리인을 통하여
        권리를 행사할 수 있으며, 이 경우 개인정보보호위원회 고시인 개인정보 처리
        방법에 관한 고시 별지 제11호에 따른 위임장을 제출하여야 합니다.
      </p>
      <p>
        4. 회사는 회원이 개인정보의 오류에 대한 정정 및 삭제를 요청한 경우에는
        적합한 조치를 완료할 때까지 당해 개인정보를 이용 또는 제공하지 않습니다.
      </p>
      <h5> 제7조 개인정보의 안전성</h5>
      확보조치  회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고
      있습니다.
      <ol>
        <li>관리적 조치 : 내부관리계획 수립∙시행, 정기적 직원 교육 등</li>
        <li>
          기술적 조치 : 접근통제시스템 설치, 중요정보의 암호화, 백신프로그램을
          이용한 컴퓨터바이러스 피해 방지, 암호알고리즘을 이용한 네트워크 상의
          개인정보 전송 보안장치(SSL), 침입차단시스템 운영 등
        </li>
        <li>물리적 조치 : 전산실, 자료보관실 등의 접근통제</li>
      </ol>
      <h5>제8조 스마트폰 내 정보 및 기능</h5>
      <p>
        접근권한에 관한 사항 회사는 서비스 제공을 위해 회원의 스마트폰 내 정보
        및 기능에 접근합니다. 회사는 회원의 최초 어플리케이션 설치 및 실행 시
        접근 항목을 명확히 인지할 수 있도록 안내 후 동의를 받고 있습니다.
      </p>
      <p>1. 접근항목 및 목적</p>
      <ul>
        <li>
          - 바이오 정보 : 서비스 이용을 위한 본인확인 수단, 로그인 비밀번호 대체
        </li>
        <li>
          - 기기정보 및 어플리케이션 기록권한: 어플리케이션 서비스 최적화 및
          오류 확인, 서비스 분석 및 통계 2. 스마트폰 접근권한 동의 또는 철회
          방법 - 안드로이드: 설정 → 앱 권한 → 접근권한 별 동의 또는 철회
          선택 (선택 접근권한에 한해서 철회 가능합니다.)
          <br />- iOS: 설정 → 앱 → 접근권한 별 동의 또는 철회 선택
        </li>
      </ul>
      <h5>
        제9조 기타 개인정보 자동수집 장치의 설치,운영 및 그 거부에 관한 사항
      </h5>
      <p>
        회사는 회원의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’등을
        운용합니다. 쿠키란 회사의 웹사이트를 운영하는데 이용되는 서버가 귀하의
        브라우저에 보내는 아주 작은 텍스트파일로써 귀하의 컴퓨터 하드디스크에
        저장됩니다.
      </p>
      <p>회사는 다음과 같은 목적을 위해 쿠키를 사용합니다.</p>
      <ol>
        <li>
          접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및
          자취 추적
        </li>
        <li>
          각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 개인 맞춤 서비스
          제공
        </li>
      </ol>
      <p>
        귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는
        웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될
        때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
      </p>
      <p>
        쿠키 설정을 거부하는 방법으로는 귀하가 사용하는 웹 브라우저의 옵션을
        선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을
        거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
        <br />
        (설정방법 예)
      </p>
      <ol>
        <li>
          마이크로소프트 엣지(Edge)의 경우 : 웹 브라우저 상단의 설정 &gt; 쿠키
          및 사이트 권한 &gt; 쿠키 및 저장된 데이터 &gt; 쿠키 및 사이트 데이터
          관리 및 삭제 &gt; 타사 쿠키 차단
        </li>
        <li>
          크롬(Chrom)의 경우 : 웹 브라우저 상단의 설정 &gt; 개인정보 및 보안
          &gt; 쿠키 및 기타 사이트 데이터 &gt; 타사 쿠키 차단
        </li>
        <li>
          사파리(Safari)의 경우 : 좌측 상단의 사파리 &gt; 설정 &gt; 개인정보
          보호 &gt; 쿠키 및 웹 사이트 데이터 &gt; 모든 쿠키 차단
        </li>
      </ol>
      <p>
        귀하께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수
        있습니다.
      </p>
      <h5>  제10조 개인정보 보호책임자 및 권익침해 구제방법에 관한 사항</h5>
      <p>
        1. 회사는 회원의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기
        위하여 아래와 같이 관련 부서 및 개인정보보호책임자를 지정하고
        있습니다. 회원은 회사의 서비스를 이용하며 발생하는 모든 개인정보보호
        관련 민원을 개인정보보호 책임자, 혹은 담당부서로 문의하실 수
        있습니다. 회사는 회원의 문의사항에 대해 신속하게 답변을 드릴 것입니다.
      </p>
      <ul>
        <li>개인정보보호 책임자 - 성명/직책 : 정규홍 / CEO</li>
        <li>- 연락처/이메일: 02-2125-4016 / psr@mobiligent.io</li>
        <li>개인정보보호 담당부서</li>
        <li>- 성명/담당부서: 양동인 / 사업팀</li>
        <li>- 연락처/이메일: 02-2125-4016 / ydi@mobiligent.io</li>
      </ul>
      <p>
        2. 기타 개인정보침해에 대한 신고나 피해구제 상담이 필요하신 경우에는
        아래 기관에 문의하시기 바랍니다.
      </p>
      <ol>
        <li>
          개인정보 침해신고센터 (한국인터넷진흥원
          운영 privacy.kisa.or.kr/국번없이 118)
        </li>
        <li> 개인정보분쟁조정위원회(www.kopico.go.kr/국번없이 1833-6972)</li>
        <li>대검찰청 사이버수사과(www.spo.go.kr/국번없이 1301)</li>
        <li>경찰청 사이버안전국(cyberbureau.police.go.kr/국번없이 182)</li>
      </ol>
      <h5>제11조 개인정보 안전성 확보조치에 관한 사항</h5>
      <p>
        회사는 개인정보의 안전성 확보를 위하여 아래와 같은 조치를 취하고
        있습니다.
      </p>
      <ul>
        <li>
          ① 내부관리계획 수립
          <ul>
            <li>
              회사는 회사가 처리하는 개인정보의 안전한 관리를 위하여 내부 관리
              계획을 수립하여 시행하고 있습니다.
            </li>
          </ul>
        </li>
        <li>
          ② 이용자의 개인정보 암호화
          <ul>
            <li>
              회사는 이용자의 중요 개인정보를 안전한 암호알고리즘에 의해
              암호화하여 저장 및 관리하고 있습니다.
            </li>
          </ul>
        </li>
        <li>
          ③ 해킹 등에 대비한 대책
          <ul>
            <li>
              회사는 해킹이나 컴퓨터 바이러스 등에 의해 이용자의 개인정보가
              유출되거나 훼손되는 것을 막기 위해 최선을 다하고
              있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고
              있고, 최신 백신 프로그램을 이용하여 이용자들의 개인정보나 자료가
              누출되거나 손상되지 않도록 방지하고 있으며, 암호화 통신 등을
              통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고
              있습니다
            </li>
          </ul>
        </li>
        <li>
          ④ 개인정보 취급자의 최소화 및 교육 ① 내부관리계획 수립
          <ul>
            <li>
              회사는 개인정보 취급자를 업무 수행에 필요한 최소한으로
              제한하며, 개인정보 취급자에 대한 교육 등 관리적 조치를 통해
              개인정보보호의 중요성을 인식시키고 있습니다.
            </li>
          </ul>
        </li>
      </ul>
      <h5>제12조 회원 유의사항</h5>
      <p>
        1. 회원의 개인정보를 최신의 상태로 정확하게 입력하여 불의의 사고를
        예방해 주시기 바랍니다. 회원이 입력한 부정확한 정보로 인해 발생하는
        사고의 책임은 회원 자신에게 있으며 타인의 정보도용 등 허위정보를 입력할
        경우 회원자격이 상실될 수 있습니다.
      </p>
      <p>
        2. 회원은 개인정보를 보호받을 권리와 함께 스스로를 보호하고 타인의
        정보를 침해하지 않을 의무도 가지고 있습니다. 비밀번호를 포함한 회원의
        개인정보가 유출되지 않도록 조심하시고 더불어 게시물을 포함한 타인의
        개인정보를 훼손하지 않도록 유의해 주시기 바랍니다.
      </p>
      <h5>제13조 개인정보처리방침 변경에 대한 공지</h5>
      <p>
        본 개인정보처리방침은 시행일로부터 적용되며, 앱 화면을 통해서 언제든
        확인이 가능합니다. 회사는 개인정보처리방침을 개정하는 경우 앱의 서비스
        공지사항을 통해서 공지합니다. <br />
      </p>
      <p>
        <br />
        <br />
        &lt;부칙 &gt;
        <br />
        1.     최초 개인정보취급방침 제정일: 2024년 04월 15일
      </p>
    </>
  );
};

export default EulaPrivacyText;
